export class StackEvents
{
    static ON_STACK_POINTER_DOWN: string = 'StackEvents.ON_STACK_POINTER_DOWN';
    static ON_STACK_POINTER_UP: string = 'StackEvents.ON_STACK_POINTER_UP';
    static ON_STACK_RIGHT_UP: string = 'StackEvents.ON_STACK_RIGHT_UP';
    static ON_STACK_TAKE_CARD: string = 'StackEvents.ON_STACK_TAKE_CARD';
    static ON_STACK_PUT_CARD: string = 'StackEvents.ON_STACK_PUT_CARD';
    static STACK_CREATED: string = 'StackEvents.STACK_CREATED';
}
